module.exports = __webpack_public_path__ + "img/damInflated.73a9ab08.svg";